import { render, staticRenderFns } from "./all-info.vue?vue&type=template&id=97346f30&scoped=true&"
import script from "./all-info.vue?vue&type=script&lang=js&"
export * from "./all-info.vue?vue&type=script&lang=js&"
import style0 from "./all-info.vue?vue&type=style&index=0&id=97346f30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97346f30",
  null
  
)

export default component.exports